import * as t from "io-ts";

const SortCodec = t.type({
  empty: t.boolean,
  sorted: t.boolean,
  unsorted: t.boolean,
});

const PageableCodec = t.type({
  pageNumber: t.number,
  pageSize: t.number,
  sort: SortCodec,
  offset: t.number,
  paged: t.boolean,
  unpaged: t.boolean,
});

export function PagedResponseCodec<T extends t.Mixed>(contentCodec: T) {
  return t.type({
    content: t.array(contentCodec),
    pageable: PageableCodec,
    last: t.boolean,
    totalElements: t.number,
    totalPages: t.number,
    size: t.number,
    number: t.number,
    sort: SortCodec,
    first: t.boolean,
    numberOfElements: t.number,
    empty: t.boolean,
  });
}

export type Sort = {
  empty: boolean,
  sorted: boolean,
  unsorted: boolean,
}

export type Pageable = {
  pageNumber: number,
  pageSize: number,
  sort: Sort,
  offset: number,
  paged: boolean,
  unpaged: boolean,
}

export type Page<T> = {
  content: T[],
  pageable: Pageable,
  last: boolean,
  totalElements: number,
  totalPages: number,
  size: number,
  number: number,
  sort: Sort,
  first: boolean,
  numberOfElements: number,
  empty: boolean,
}
